import MainInformationTypes from 'Containers/MainInformations/types'

const INITIAL_STATE = {
  pageUnderEdition: false,
  controlUnderEdition: false,
  widgetConfiguration: {
    conditionIsBeingEdited: false,
  },
  checkPassword: {
    checkPasswordResult : false,
    passwordIsChecked : false,
  },
}

const mainInformationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch(type) {
    case MainInformationTypes.RESET_PAGE_EDITION:
      return {
        ...state,
        pageUnderEdition: false,
      }
    case MainInformationTypes.SET_PAGE_EDITION:
      return {
        ...state,
        pageUnderEdition: payload
      }
    case MainInformationTypes.SET_CHECK_PASSWORD_RESULT:
      return {
        ...state,
        checkPassword : {
          ...state.checkPassword,
          checkPasswordResult: payload
        }
      }
    case MainInformationTypes.SET_PASSWORD_IS_CHECKED:
      return {
        ...state,
        checkPassword : {
          ...state.checkPassword,
          passwordIsChecked: payload
        }
      }
    case MainInformationTypes.CHANGE_WIDGET_CONDITION_EDITION_STATUS:
      return {
        ...state,
        widgetConfiguration : {
          ...state.widgetConfiguration,
          conditionIsBeingEdited: payload
        }
      }
    case MainInformationTypes.SET_CONTROL_EDITION:
      return {
        ...state,
        controlUnderEdition: true
      }
    case MainInformationTypes.RESET_CONTROL_EDITION:
      return {
        ...state,
        controlUnderEdition: false
      }
    default: return state
  }
}

export default mainInformationReducer